import { useState } from 'react';
import AgentDrawer from './agents/AgentDrawer';
import KnowledgePanel from './KnowledgePanel';
import type { KnowledgeAgentScope } from '../types';

interface KnowledgeSuggestLauncherProps {
  scope: KnowledgeAgentScope;
  scopeId: number;
  scopeName?: string;
}

/**
 * "Suggest knowledge" entry point for the settings → knowledge page. Opens the
 * chat-driven KnowledgePanel in a wide slide-out; applying suggestions there
 * commits proposals to the brief, which the KnowledgeBriefPanel rendered just
 * below this launcher refreshes on the resulting `knowledge_plan` WebSocket
 * event. Lives here (next to the brief) rather than on the keyword browse pages
 * so those reclaim the screen real estate.
 */
export default function KnowledgeSuggestLauncher({
  scope,
  scopeId,
  scopeName,
}: KnowledgeSuggestLauncherProps) {
  const [open, setOpen] = useState(false);
  return (
    <div className="mb-4 flex items-center justify-between gap-3">
      <p className="text-sm text-gray-500 dark:text-gray-400">
        Chat with the knowledge agent to discover bedrock facts, then apply them
        to the brief below.
      </p>
      <button
        onClick={() => setOpen(true)}
        className="px-4 py-2 bg-indigo-600 text-white text-sm font-medium rounded hover:bg-indigo-700 whitespace-nowrap"
      >
        Suggest knowledge
      </button>
      <AgentDrawer
        open={open}
        onClose={() => setOpen(false)}
        title={`Knowledge agent · ${scope}`}
        subtitle={scopeName}
        size="wide"
      >
        <KnowledgePanel scope={scope} scopeId={scopeId} scopeName={scopeName} />
      </AgentDrawer>
    </div>
  );
}
